
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Punetonearbyplaces() {



    const cardData =
    {
        keyword: 'Pune to Nearby Places Picnic Spot Bus On Rent',
        heading: 'Amruta Travels: Pune to Nearby Places Picnic Spot Bus On Rent',
        headingDescription: 'Amruta Travels offers Bus on Rent from Pune to Nearby Picnic Spots, providing a reliable and comfortable travel solution for family outings, corporate picnics, school trips, and group tours. Whether you are heading to Lonavala, Lavasa, Matheran, Sinhagad, Mulshi, or other scenic destinations around Pune, our well-maintained buses ensure a smooth, enjoyable, and stress-free journey.',


        top: 'Top Places to Visit in Outstation Pune with Amruta Travels',



"topPlaces": [
  {
    "title": "Mahabaleshwar",
    "description": "Located around 120 km from Pune, Mahabaleshwar is a scenic hill station famous for its strawberry farms, lush valleys, and viewpoints like Arthur’s Seat and Wilson Point. It's an ideal spot for nature lovers and weekend getaways."
  },
  {
    "title": "Lonavala & Khandala",
    "description": "Just 66 km from Pune, these twin hill stations in the Sahyadri range are popular for their green valleys, monsoon waterfalls, and attractions like Bhushi Dam and Tiger’s Leap. Great for a quick escape from city life."
  },
  {
    "title": "Shirdi",
    "description": "About 190 km from Pune, Shirdi is a major pilgrimage town dedicated to Sai Baba. The Sai Baba Temple attracts millions of devotees annually. The spiritual atmosphere makes it perfect for religious tourism."
  },
  {
    "title": "Goa",
    "description": "Located nearly 450 km from Pune, Goa is the ultimate beach holiday destination. From vibrant nightlife and water sports to heritage forts and churches, Goa offers something for every traveler."
  },
  {
    "title": "Nashik",
    "description": "Around 210 km from Pune, Nashik is known for its religious significance and as India’s wine capital. Key attractions include the Kalaram Temple, Sula Vineyards, and Trimbakeshwar Temple."
  },
  {
    "title": "Alibaug",
    "description": "Situated 140 km away, Alibaug is a coastal town with serene beaches like Nagaon and historical forts such as Kolaba Fort. It’s a popular choice for beach lovers and family picnics."
  },
  {
    "title": "Kolhapur",
    "description": "Roughly 235 km from Pune, Kolhapur is home to the famous Mahalaxmi Temple and is known for its rich cultural heritage and spicy cuisine. It also offers attractions like Rankala Lake and Panhala Fort."
  },
  {
    "title": "Lavasa",
    "description": "Just 60 km from Pune, Lavasa is a planned city nestled in the Western Ghats, offering lakeside views, water sports, and a peaceful retreat. Perfect for a one-day outing or weekend stay."
  },
  {
    "title": "Satara & Kaas Plateau",
    "description": "About 120 km from Pune, Satara is a gateway to the Kaas Plateau, a UNESCO-listed biodiversity hotspot. Visit during the monsoon to witness a stunning bloom of wildflowers across the valley."
  },
  {
    "title": "Aurangabad",
    "description": "Situated 235 km from Pune, Aurangabad is known for the Ajanta and Ellora Caves (UNESCO World Heritage Sites), Bibi Ka Maqbara, and Daulatabad Fort. A must-visit for history and architecture enthusiasts."
  }
],

    "services": [
    {
      "name": "Pune to Malshej Ghat Picnic Bus On Rent",
      "description": "Enjoy a scenic trip to Malshej Ghat with Amruta Travels. Rent a bus for your group picnic, with comfortable seating, air conditioning, and experienced drivers to ensure a smooth and memorable journey."
    },
    {
      "name": "Pune to Sinhagad Fort 14-17 Seater Bus On Rent",
      "description": "Take a trip to the historic Sinhagad Fort with our 14-17 seater buses on rent. Amruta Travels provides comfortable and affordable transportation for group outings to Sinhagad Fort."
    },
    {
      "name": "20 Seater Tempo Traveller on Rent in Pune",
      "description": "Rent a 20-seater Tempo Traveller for your group outing, picnic, or event in Pune. These spacious vehicles are perfect for comfortable travel with friends or family, with ample space for luggage and seating."
    },
    {
      "name": "Pune to Matheran Bus on Rent",
      "description": "Travel to the beautiful hill station of Matheran with Amruta Travels. Our buses are perfect for group trips to Matheran, offering comfort, convenience, and safety for your journey."
    },
    {
      "name": "Lonavala to Lavasa Bus Hire for Picnic",
      "description": "Make your picnic trip from Lonavala to Lavasa unforgettable with a bus rental from Amruta Travels. Our buses offer AC comfort, spacious seating, and smooth rides to ensure a relaxing journey."
    },
    {
      "name": "Pune to Agra Bus Hire for Picnic",
      "description": "Plan an exciting group trip to Agra with Amruta Travels. Our buses offer premium travel services, ensuring comfort for your long-distance journey to Agra for a historical outing."
    },
    {
      "name": "Kashi Darshan Bus On Rent from Pune",
      "description": "Embark on a spiritual journey to Kashi with Amruta Travels. Our buses are well-equipped for long-distance travel, providing comfort and safety during your religious tour to Kashi."
    },
    {
      "name": "Pune to Shani Shingnapur Bus Hire",
      "description": "Rent a bus to visit the famous Shani Shingnapur temple from Pune. Amruta Travels provides well-maintained buses for group travel, ensuring comfort and timely arrival for your spiritual journey."
    },
    {
      "name": "Pune to Lavasa Tempo Traveller Hire",
      "description": "For a scenic and comfortable trip to Lavasa, rent a Tempo Traveller from Amruta Travels. Our vehicles offer a smooth ride with comfortable seating, perfect for group trips or family outings."
    },
    {
      "name": "Pune to Adlabs Imagica Bus Hire",
      "description": "Book a bus for your trip to Adlabs Imagica with Amruta Travels. Enjoy a thrilling experience at the amusement park with comfortable transport, ideal for school trips, family outings, and corporate events."
    },
    {
      "name": "School Buses for Field Trips Near Me in Pune",
      "description": "Amruta Travels provides school bus rentals for field trips near Pune. Our buses are well-maintained, safe, and equipped with all necessary amenities, ensuring a safe and enjoyable trip for students."
    },
    {
      "name": "Pune to Jejuri Bus On Rent",
      "description": "Plan a pilgrimage trip to Jejuri with Amruta Travels. We offer buses on rent for your journey, providing comfort and reliability for your spiritual journey to the Jejuri temple."
    },
    {
      "name": "Pune to Imagica Bus Hire",
      "description": "Rent a bus from Amruta Travels for a fun-filled day at Imagica. Whether it's a family outing or a corporate event, our buses offer comfortable and safe travel to the famous amusement park."
    },
    {
      "name": "Pune to Lavasa Bus Hire On Rent",
      "description": "Rent a bus from Amruta Travels for your scenic trip to Lavasa. Our buses provide a comfortable and smooth ride to the hill station, ideal for group outings and corporate trips."
    },
    {
      "name": "Pune to Ketkawale Balaji Temple Bus On Rent",
      "description": "Amruta Travels offers buses for a religious journey to Ketkawale Balaji Temple. Rent a bus for your group, ensuring a comfortable and timely arrival at the temple."
    },
    {
      "name": "Pune to Bhushi Dam Bus on Rent",
      "description": "Take a trip to the beautiful Bhushi Dam with Amruta Travels. Rent a bus for your group outing, ensuring comfort and convenience with our well-maintained buses for the scenic journey."
    }
  ],
  "tableData": [
    ["Pune to Malshej Ghat Picnic Bus On Rent", "Pune to Sinhagad Fort 14-17 Seater Bus On Rent"],
    ["20 Seater Tempo Traveller on Rent in Pune", "Pune to Matheran Bus on Rent"],
    ["Lonavala to Lavasa Bus Hire for Picnic", "Pune to Agra Bus Hire for Picnic"],
    ["Kashi Darshan Bus On Rent from Pune", "Pune to Shani Shingnapur Bus Hire"],
    ["Pune to Lavasa Tempo Traveller Hire", "Pune to Adlabs Imagica Bus Hire"],
    ["School Buses for Field Trips Near Me in Pune", "Pune to Jejuri Bus On Rent"],
    ["Pune to Imagica Bus Hire", "Pune to Lavasa Bus Hire On Rent"],
    ["Pune to Ketkawale Balaji Temple Bus On Rent", "Pune to Bhushi Dam Bus on Rent"]
  ],




"whychoose": [
  {
    "WhyChooseheading": "Perfect Bus Rentals for Picnic Spots Near Pune",
    "WhyChoosedescription": "Amruta Travels offers bus rentals for group trips to nearby picnic spots around Pune. Whether you're heading to Lavasa, Lonavala, Khandala, or Mulshi Lake, our buses provide a comfortable and hassle-free way for large groups to travel, ensuring everyone enjoys the journey as much as the destination."
  },
  {
    "WhyChooseheading": "Ideal for Group Picnic, Corporate Outings, and Family Gatherings",
    "WhyChoosedescription": "Our buses are perfect for group picnics, family getaways, corporate outings, and school trips. With spacious seating, air conditioning, and ample storage for picnic gear, our buses ensure a smooth and enjoyable journey to your chosen picnic spot near Pune."
  },
  {
    "WhyChooseheading": "Affordable Pricing for Picnic Spot Bus Rentals",
    "WhyChoosedescription": "Amruta Travels offers affordable and transparent pricing for bus rentals to nearby picnic spots from Pune. Our all-inclusive pricing covers fuel, tolls, driver fees, and taxes, with no hidden charges. This allows you to stay within your budget while enjoying a comfortable trip to scenic destinations."
  },
  {
    "WhyChooseheading": "Comfortable and Modern Amenities for Your Picnic Trip",
    "WhyChoosedescription": "Our buses come equipped with modern amenities like air conditioning, comfortable seating, entertainment systems, and USB charging points. Whether you're traveling to a nearby hill station or lakeside picnic spot, our buses ensure that your group enjoys a relaxing and comfortable ride."
  },
  {
    "WhyChooseheading": "Experienced and Friendly Drivers for Safe Travel",
    "WhyChoosedescription": "Our experienced and friendly drivers are well-acquainted with the best routes to nearby picnic spots. They ensure safe, smooth, and timely travel, allowing you to focus on enjoying the trip with your group. They also offer assistance with directions and other travel-related queries along the way."
  },
  {
    "WhyChooseheading": "Ideal for Short Trips to Nearby Picnic Spots from Pune",
    "WhyChoosedescription": "Whether you're planning a short getaway to Lonavala, Khandala, Malshej Ghat, or any other scenic picnic spot, our buses provide an ideal and convenient way to transport your group. With comfortable seating and ample space for picnic items, our buses make the journey to nearby destinations a breeze."
  },
  {
    "WhyChooseheading": "Flexible Rental Duration and Easy Booking Process",
    "WhyChoosedescription": "We offer flexible rental durations for your picnic trips, whether it’s a day trip or a weekend getaway. Booking a bus with Amruta Travels is easy and hassle-free through our online platform, and our customer support team is always ready to assist with any last-minute changes or inquiries."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for a Smooth Experience",
    "WhyChoosedescription": "Amruta Travels offers 24/7 customer support to ensure your trip to nearby picnic spots goes smoothly. Whether you need help with booking, itinerary changes, or have any questions during the trip, our team is always available to provide assistance and ensure a pleasant travel experience."
  }
]























    }

const faqData = [
  {
    question: 'Can I rent a bus for a picnic trip from Pune to nearby places?',
    answer: 'Yes, Amruta Travels offers bus rentals for picnic trips to nearby places from Pune. Whether you’re planning a family outing, corporate event, or group tour to spots like Lonavala, Khandala, Mahabaleshwar, or Matheran, we have the perfect bus for your needs.',
  },
  {
    question: 'What types of buses are available for renting for a picnic trip from Pune?',
    answer: 'We offer a variety of buses for rent, including 17-seater, 32-seater, and 50-seater buses, depending on the size of your group. All our buses are comfortable and well-maintained, perfect for a day trip or weekend getaway.',
  },
  {
    question: 'Are drivers included with the picnic bus rentals?',
    answer: 'Yes, all our bus rentals for picnic trips include professional, experienced drivers. Our drivers are knowledgeable of local routes, ensuring a smooth and safe trip to nearby picnic spots.',
  },
  {
    question: 'How much does it cost to rent a bus for a picnic from Pune?',
    answer: 'The rental cost depends on the bus type, trip duration, and distance. For nearby destinations, prices start at ₹25-35 per km for smaller buses like the 17-seater, and higher for larger buses. Please contact us for a customized quote based on your specific trip details.',
  },
  {
    question: 'Can I rent a bus for a one-day picnic trip?',
    answer: 'Yes, our buses are available for one-day picnic trips as well as weekend getaways. We offer flexible rental options to suit the duration and itinerary of your trip.',
  },
  {
    question: 'Are the buses well-maintained and sanitized for the picnic trip?',
    answer: 'Yes, all our buses are regularly serviced, well-maintained, and thoroughly sanitized before each trip to ensure the highest standards of comfort and hygiene.',
  },
  {
    question: 'Can I book a bus for a picnic trip online?',
    answer: 'Yes, you can easily book a bus for your picnic trip online through our website or by contacting our team directly. We will assist you with all the necessary details to ensure your trip is organized and hassle-free.',
  },
  {
    question: 'What are some popular picnic spots near Pune that I can visit by bus?',
    answer: 'Some popular picnic spots near Pune that you can visit by bus include Lonavala, Khandala, Mahabaleshwar, Matheran, Panchgani, Lavasa, and Sinhagad Fort. These destinations are perfect for a relaxing group trip.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Vijay Patil',
    role: 'Business Owner, Pune',
    text: 'We rented a bus for a picnic trip to Lonavala from Pune. The bus was comfortable, well-maintained, and the driver was professional. Our group had a great time, and the trip was hassle-free. Highly recommend Amruta Travels!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Radhika Shah',
    role: 'Event Organizer, Pune',
    text: 'We hired a 32-seater bus for a family picnic to Mahabaleshwar. The service was excellent, the bus was clean, and the driver ensured that we had a safe and comfortable journey. Amruta Travels made our trip enjoyable!',
    rating: 5,
  },
];














































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Nearby Places Picnic Spot Bus On Rent",
  "image": "https://bushireinpune.com/assets/images/picnic-spot-bus-hire.jpg", // Update with actual image URL
  "description": "Rent a bus from Pune to popular picnic spots like Malshej Ghat, Sinhagad Fort, Matheran, Imagica, Lavasa, and more. 14 to 50-seater buses available for your next family or group outing.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "620"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2500", // Adjust price based on service details
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/pune-to-nearby-places-picnic-spot-bus-on-rent"
  }
};






    return (
        <div>

<Helmet>
  <title>Call: +91 7353109555 | Pune to Nearby Places Picnic Spot Bus on Rent | Bus Rental for Malshej Ghat, Sinhagad, Imagica</title>
  <meta 
    name="description" 
    content="Book a bus for picnic trips from Pune to Malshej Ghat, Sinhagad Fort, Matheran, Lavasa, Imagica, and more. 14-50 Seater buses available for family and group outings at affordable prices." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/78.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetonearbyplaces;